// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   NAPLEX PREP DLC PAGE — Dark glassmorphism theme
   Matches Landing + Pricing design language
   Green accent (#10b981 / #34d399)
   ============================================ */

/* ---- Layout ---- */
.naplex-prep {
  min-height: 100vh;
  background: var(--bg-base);
  color: var(--text-primary);
  font-family: var(--font-primary);
  position: relative;
  overflow-x: hidden;
  padding-top: 64px;
}

/* ---- Ambient background glows ---- */
.naplex-prep-bg {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.naplex-prep-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  opacity: 0.12;
}

.naplex-prep-glow-1 {
  width: 600px;
  height: 600px;
  background: #10b981;
  top: -200px;
  left: 50%;
  transform: translateX(-50%);
  animation: naplex-drift 20s ease-in-out infinite alternate;
}

.naplex-prep-glow-2 {
  width: 500px;
  height: 500px;
  background: #ef4444;
  bottom: 20%;
  left: -150px;
  animation: naplex-drift 25s ease-in-out infinite alternate-reverse;
}

.naplex-prep-glow-3 {
  width: 400px;
  height: 400px;
  background: #0ea5e9;
  bottom: 10%;
  right: -100px;
  animation: naplex-drift 22s ease-in-out infinite alternate;
}

@keyframes naplex-drift {
  0% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(30px, -20px) scale(1.05); }
  100% { transform: translate(-20px, 15px) scale(0.95); }
}

/* ---- Top bar (matches real TopNav: full-width, fixed, blurred backdrop) ---- */
.naplex-prep-topbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  background: rgba(10, 10, 10, 0.95);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  z-index: 1000;
  display: flex;
  align-items: center;
}

.naplex-prep-topbar-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.naplex-prep-topbar-logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  gap: 0.5rem;
  padding: 0.25rem 0;
  transition: opacity 0.2s ease;
}

.naplex-prep-topbar-logo:hover {
  opacity: 0.85;
}

.naplex-prep-topbar-bono {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: 0.28em;
  color: #ffffff;
  text-transform: uppercase;
  line-height: 1;
}

.naplex-prep-topbar-favicon {
  height: 32px;
  width: 32px;
  display: block;
  object-fit: contain;
}

.naplex-prep-topbar-rx {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #f87171;
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.4);
  border-radius: 9999px;
  padding: 0.25rem 0.6rem;
  margin-left: 0.5rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
}

/* logo hover handled by parent opacity */

.naplex-prep-topbar-links {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.naplex-prep-topbar-links a {
  color: #9ca3af;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.9375rem;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: all 0.2s ease;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.naplex-prep-topbar-links a:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.05);
}

.naplex-prep-topbar-cta {
  padding: 0.5rem 1rem !important;
  background: rgba(59, 130, 246, 0.15) !important;
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 8px !important;
  color: #60a5fa !important;
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  transition: all 0.2s ease !important;
}

.naplex-prep-topbar-cta:hover {
  background: rgba(59, 130, 246, 0.25) !important;
  border-color: rgba(59, 130, 246, 0.5);
  color: #93c5fd !important;
  transform: translateY(-1px);
}

/* ---- Section wrapper ---- */
.naplex-prep-inner {
  position: relative;
  z-index: 1;
  max-width: var(--container-content);
  margin: 0 auto;
  padding: 0 var(--space-6);
}

/* ---- Hero ---- */
.naplex-prep-hero {
  text-align: center;
  padding: clamp(4rem, 10vh, 7rem) 0 var(--space-12);
}

.naplex-prep-badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  background: rgba(16, 185, 129, 0.12);
  border: 1px solid rgba(16, 185, 129, 0.3);
  color: #34d399;
  font-size: var(--text-xs);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: var(--tracking-wider);
  padding: var(--space-1) var(--space-4);
  border-radius: var(--radius-full);
  margin-bottom: var(--space-6);
}

.naplex-prep-hero h1 {
  font-size: clamp(2rem, 5vw, 3.5rem);
  font-weight: var(--font-weight-bold);
  line-height: var(--leading-tight);
  margin: 0 0 var(--space-4);
  filter: drop-shadow(0 0 60px rgba(16, 185, 129, 0.15));
}

.naplex-prep-hero h1 span {
  background: linear-gradient(135deg, #34d399, #10b981, #059669);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.naplex-prep-hero-sub {
  font-size: var(--text-lg);
  color: var(--text-muted);
  max-width: 640px;
  margin: 0 auto var(--space-8);
  line-height: var(--leading-relaxed);
}

.naplex-prep-hero-cta {
  display: flex;
  gap: var(--space-4);
  justify-content: center;
  flex-wrap: wrap;
}

.naplex-prep-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-8);
  background: rgba(16, 185, 129, 0.15);
  border: 1px solid rgba(16, 185, 129, 0.4);
  color: #34d399;
  font-size: var(--text-base);
  font-weight: var(--font-weight-semibold);
  border-radius: var(--radius-lg);
  cursor: pointer;
  text-decoration: none;
  transition: all var(--transition-normal);
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.naplex-prep-btn-primary:hover {
  background: rgba(16, 185, 129, 0.25);
  border-color: rgba(16, 185, 129, 0.6);
  transform: translateY(-1px);
  box-shadow: 0 4px 20px rgba(16, 185, 129, 0.2);
}

.naplex-prep-btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-8);
  background: transparent;
  border: 1px solid var(--border-default);
  color: var(--text-secondary);
  font-size: var(--text-base);
  font-weight: var(--font-weight-medium);
  border-radius: var(--radius-lg);
  cursor: pointer;
  text-decoration: none;
  transition: all var(--transition-normal);
}

.naplex-prep-btn-ghost:hover {
  border-color: var(--border-strong);
  color: var(--text-primary);
  transform: translateY(-1px);
}

/* ---- Stat strip ---- */
.naplex-prep-stats {
  display: flex;
  justify-content: center;
  gap: var(--space-10);
  flex-wrap: wrap;
  padding: var(--space-8) 0;
  border-top: 1px solid var(--border-subtle);
  border-bottom: 1px solid var(--border-subtle);
  margin-bottom: var(--space-16);
}

.naplex-prep-stat {
  text-align: center;
}

.naplex-prep-stat-value {
  font-size: var(--text-3xl);
  font-weight: var(--font-weight-bold);
  color: #34d399;
  display: block;
}

.naplex-prep-stat-label {
  font-size: var(--text-sm);
  color: var(--text-muted);
  margin-top: var(--space-1);
}

/* ---- Section headings ---- */
.naplex-prep-section {
  margin-bottom: var(--space-16);
}

.naplex-prep-section-header {
  text-align: center;
  margin-bottom: var(--space-8);
}

.naplex-prep-section-header h2 {
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: var(--font-weight-bold);
  margin: 0 0 var(--space-3);
}

.naplex-prep-section-header p {
  font-size: var(--text-base);
  color: var(--text-muted);
  max-width: 600px;
  margin: 0 auto;
  line-height: var(--leading-relaxed);
}

/* ---- How it works — 3-step flow ---- */
.naplex-prep-flow {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto 1fr;
  gap: var(--space-4);
  align-items: stretch;
}

.naplex-prep-flow-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-subtle);
  font-size: 1.5rem;
}

.naplex-prep-flow-card {
  background: var(--bg-card);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-2xl);
  padding: var(--space-6);
  backdrop-filter: var(--glass-blur);
  transition: all var(--transition-normal);
}

.naplex-prep-flow-card:hover {
  border-color: var(--border-default);
  transform: translateY(-4px);
}

.naplex-prep-flow-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--space-3);
}

.naplex-prep-flow-num--1 {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.naplex-prep-flow-num--2 {
  background: rgba(16, 185, 129, 0.15);
  color: #34d399;
  border: 1px solid rgba(16, 185, 129, 0.3);
}

.naplex-prep-flow-num--3 {
  background: rgba(34, 197, 94, 0.15);
  color: #22c55e;
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.naplex-prep-flow-card h3 {
  font-size: var(--text-lg);
  font-weight: var(--font-weight-semibold);
  margin: 0 0 var(--space-2);
}

.naplex-prep-flow-card p {
  font-size: var(--text-sm);
  color: var(--text-muted);
  line-height: var(--leading-relaxed);
  margin: 0;
}

/* ---- Therapeutic areas grid ---- */
.naplex-prep-areas-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-4);
}

.naplex-prep-area-card {
  position: relative;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: var(--radius-2xl);
  padding: var(--space-5);
  backdrop-filter: var(--glass-blur-strong);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(25% - 12px);
  min-width: 210px;
}

.naplex-prep-area-card-glow {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 80px;
  background: var(--area-color);
  border-radius: 50%;
  filter: blur(50px);
  opacity: 0.08;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.naplex-prep-area-card:hover {
  border-color: var(--area-color, var(--border-default));
  transform: translateY(-4px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3),
              0 0 0 1px var(--area-color, transparent);
  background: rgba(255, 255, 255, 0.05);
}

.naplex-prep-area-card:hover .naplex-prep-area-card-glow {
  opacity: 0.18;
}

.naplex-prep-area-header {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.naplex-prep-area-dot {
  width: 10px;
  height: 10px;
  border-radius: var(--radius-full);
  flex-shrink: 0;
  background: var(--area-color);
  box-shadow: 0 0 8px var(--area-color);
}

.naplex-prep-area-name {
  font-size: var(--text-sm);
  font-weight: var(--font-weight-semibold);
}

.naplex-prep-area-nodes {
  display: flex;
  gap: var(--space-2);
  flex-wrap: wrap;
}

.naplex-prep-area-node {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: var(--text-xs);
  color: var(--text-muted);
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: var(--radius-md);
  padding: 3px 7px;
}

.naplex-prep-area-node svg {
  color: var(--area-color);
  opacity: 0.8;
  flex-shrink: 0;
}

/* Totals card — stands out from per-area cards */
.naplex-prep-area-card--totals {
  background: rgba(16, 185, 129, 0.05);
  border-color: rgba(16, 185, 129, 0.2);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(50% - 8px);
}

.naplex-prep-area-card--totals .naplex-prep-area-name {
  color: #34d399;
  font-size: var(--text-base);
}

.naplex-prep-area-card--totals .naplex-prep-area-nodes {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--space-2);
}

.naplex-prep-area-card--totals .naplex-prep-area-node {
  background: rgba(16, 185, 129, 0.06);
  border-color: rgba(16, 185, 129, 0.12);
  min-width: 0;
  justify-content: center;
  padding: 3px 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.naplex-prep-area-card--totals .naplex-prep-area-node span {
  color: var(--text-primary);
  font-weight: var(--font-weight-semibold);
}

.naplex-prep-area-card--totals .naplex-prep-area-node--label {
  color: var(--text-secondary);
  font-weight: var(--font-weight-medium);
}

/* ---- Yield spectrum ---- */
.naplex-prep-yield {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-4);
}

.naplex-prep-yield-card {
  background: var(--bg-card);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-2xl);
  padding: var(--space-6);
  backdrop-filter: var(--glass-blur);
  transition: all var(--transition-normal);
}

.naplex-prep-yield-card:hover {
  border-color: var(--border-default);
}

.naplex-prep-yield-card h3 {
  font-size: var(--text-lg);
  font-weight: var(--font-weight-semibold);
  margin: 0 0 var(--space-2);
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.naplex-prep-yield-tag {
  font-size: var(--text-xs);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: var(--tracking-wider);
  padding: 2px var(--space-2);
  border-radius: var(--radius-sm);
}

.naplex-prep-yield-tag--high {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.naplex-prep-yield-tag--medium {
  background: rgba(245, 158, 11, 0.15);
  color: #f59e0b;
  border: 1px solid rgba(245, 158, 11, 0.3);
}

.naplex-prep-yield-tag--low {
  background: rgba(14, 165, 233, 0.15);
  color: #0ea5e9;
  border: 1px solid rgba(14, 165, 233, 0.3);
}

.naplex-prep-yield-card p {
  font-size: var(--text-sm);
  color: var(--text-muted);
  line-height: var(--leading-relaxed);
  margin: 0 0 var(--space-3);
}

.naplex-prep-yield-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.naplex-prep-yield-list li {
  font-size: var(--text-sm);
  color: var(--text-secondary);
  padding: var(--space-1) 0;
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
}

.naplex-prep-yield-list li::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: var(--radius-full);
  background: var(--text-subtle);
  flex-shrink: 0;
  margin-top: 7px;
}

/* ---- Node types (what you encounter) ---- */
.naplex-prep-nodes {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--space-4);
}

.naplex-prep-node-card {
  background: var(--bg-card);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-2xl);
  padding: var(--space-6);
  backdrop-filter: var(--glass-blur);
  transition: all var(--transition-normal);
}

.naplex-prep-node-card:hover {
  border-color: var(--border-default);
  transform: translateY(-2px);
}

.naplex-prep-node-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--radius-lg);
  margin-bottom: var(--space-3);
}

.naplex-prep-node-card h3 {
  font-size: var(--text-base);
  font-weight: var(--font-weight-semibold);
  margin: 0 0 var(--space-2);
}

.naplex-prep-node-card p {
  font-size: var(--text-sm);
  color: var(--text-muted);
  line-height: var(--leading-relaxed);
  margin: 0;
}

/* ---- Differentiators — comparison ---- */
.naplex-prep-compare {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-6);
}

.naplex-prep-compare-card {
  background: var(--bg-card);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-2xl);
  padding: var(--space-6);
  backdrop-filter: var(--glass-blur);
}

.naplex-prep-compare-card--them {
  opacity: 0.7;
}

.naplex-prep-compare-card--us {
  border-color: rgba(16, 185, 129, 0.3);
}

.naplex-prep-compare-label {
  font-size: var(--text-xs);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: var(--tracking-widest);
  color: var(--text-subtle);
  margin-bottom: var(--space-4);
}

.naplex-prep-compare-card--us .naplex-prep-compare-label {
  color: #34d399;
}

.naplex-prep-compare-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.naplex-prep-compare-list li {
  font-size: var(--text-sm);
  color: var(--text-secondary);
  padding: var(--space-2) 0;
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  line-height: var(--leading-relaxed);
}

.naplex-prep-compare-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.naplex-prep-compare-card--them .naplex-prep-compare-icon {
  color: var(--text-subtle);
}

.naplex-prep-compare-card--us .naplex-prep-compare-icon {
  color: #22c55e;
}

/* ---- Bottom CTA ---- */
.naplex-prep-bottom-cta {
  text-align: center;
  padding: var(--space-16) 0;
  border-top: 1px solid var(--border-subtle);
}

.naplex-prep-bottom-cta h2 {
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: var(--font-weight-bold);
  margin: 0 0 var(--space-3);
}

.naplex-prep-bottom-cta p {
  font-size: var(--text-base);
  color: var(--text-muted);
  margin: 0 0 var(--space-6);
}

.naplex-prep-price-display {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: var(--space-2);
  margin-bottom: var(--space-6);
}

.naplex-prep-price-amount {
  font-size: var(--text-4xl);
  font-weight: var(--font-weight-bold);
  color: #34d399;
}

.naplex-prep-price-period {
  font-size: var(--text-lg);
  color: var(--text-muted);
}

.naplex-prep-price-note {
  font-size: var(--text-sm);
  color: var(--text-subtle);
  margin-bottom: var(--space-6);
}

/* ---- Footer nav ---- */
.naplex-prep-footer {
  text-align: center;
  padding: var(--space-8) 0;
  border-top: 1px solid var(--border-subtle);
}

.naplex-prep-footer-links {
  display: flex;
  justify-content: center;
  gap: var(--space-6);
  flex-wrap: wrap;
}

.naplex-prep-footer-links a {
  font-size: var(--text-sm);
  color: var(--text-muted);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.naplex-prep-footer-links a:hover {
  color: var(--text-primary);
}

/* ---- Scroll animation (reuses landing pattern) ---- */
.naplex-animate {
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

.naplex-animate.naplex-visible {
  opacity: 1;
  transform: translateY(0);
}

/* Stagger children */
.naplex-prep-areas-grid .naplex-animate:nth-child(1) { transition-delay: 0s; }
.naplex-prep-areas-grid .naplex-animate:nth-child(2) { transition-delay: 0.03s; }
.naplex-prep-areas-grid .naplex-animate:nth-child(3) { transition-delay: 0.06s; }
.naplex-prep-areas-grid .naplex-animate:nth-child(4) { transition-delay: 0.09s; }
.naplex-prep-areas-grid .naplex-animate:nth-child(5) { transition-delay: 0.12s; }
.naplex-prep-areas-grid .naplex-animate:nth-child(6) { transition-delay: 0.15s; }
.naplex-prep-areas-grid .naplex-animate:nth-child(7) { transition-delay: 0.18s; }
.naplex-prep-areas-grid .naplex-animate:nth-child(8) { transition-delay: 0.21s; }
.naplex-prep-areas-grid .naplex-animate:nth-child(9) { transition-delay: 0.24s; }
.naplex-prep-areas-grid .naplex-animate:nth-child(10) { transition-delay: 0.27s; }
.naplex-prep-areas-grid .naplex-animate:nth-child(11) { transition-delay: 0.30s; }
.naplex-prep-areas-grid .naplex-animate:nth-child(12) { transition-delay: 0.33s; }
.naplex-prep-areas-grid .naplex-animate:nth-child(13) { transition-delay: 0.36s; }
.naplex-prep-areas-grid .naplex-animate:nth-child(14) { transition-delay: 0.39s; }
.naplex-prep-areas-grid .naplex-animate:nth-child(15) { transition-delay: 0.42s; }
.naplex-prep-areas-grid .naplex-animate:nth-child(16) { transition-delay: 0.45s; }

.naplex-prep-nodes .naplex-animate:nth-child(1) { transition-delay: 0s; }
.naplex-prep-nodes .naplex-animate:nth-child(2) { transition-delay: 0.06s; }
.naplex-prep-nodes .naplex-animate:nth-child(3) { transition-delay: 0.12s; }
.naplex-prep-nodes .naplex-animate:nth-child(4) { transition-delay: 0.18s; }
.naplex-prep-nodes .naplex-animate:nth-child(5) { transition-delay: 0.24s; }
.naplex-prep-nodes .naplex-animate:nth-child(6) { transition-delay: 0.30s; }

/* ---- Responsive ---- */
@media (max-width: 768px) {
  .naplex-prep-flow {
    grid-template-columns: 1fr;
    gap: var(--space-3);
  }

  .naplex-prep-flow-arrow {
    transform: rotate(90deg);
    padding: var(--space-1) 0;
  }

  .naplex-prep-nodes {
    grid-template-columns: 1fr;
  }

  .naplex-prep-compare {
    grid-template-columns: 1fr;
  }

  .naplex-prep-yield {
    grid-template-columns: 1fr;
  }

  .naplex-prep-area-card {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50% - 8px);
    min-width: 140px;
  }

  .naplex-prep-area-card--totals {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50% - 8px);
  }

  .naplex-prep-stats {
    gap: var(--space-6);
  }

  .naplex-prep-area-card--totals .naplex-prep-area-nodes {
    grid-template-columns: repeat(4, 1fr);
  }

  /* Thumb-sized tap targets: keep the compact type, grow the hit area to
     ~40px via min-height + flex centering (Edward 2026-06-12 mobile pass). */
  .naplex-prep-topbar-links a {
    font-size: 0.8125rem;
    padding: 0.375rem 0.5rem;
    min-height: 40px;
    display: inline-flex;
    align-items: center;
  }

  .naplex-prep-topbar-links {
    gap: 0.25rem;
  }

  .naplex-prep-topbar-cta {
    padding: 0.375rem 0.625rem !important;
    font-size: 0.8125rem !important;
  }

  .naplex-prep-topbar-logo {
    padding: 0.5rem 0;
    min-height: 40px;
  }

  .naplex-prep-topbar-container {
    padding: 0 1rem;
  }

  .naplex-prep-footer-links a {
    padding: 0.625rem 0.5rem;
    display: inline-flex;
    align-items: center;
  }
}

@media (max-width: 480px) {
  .naplex-prep-inner {
    padding: 0 var(--space-4);
  }

  .naplex-prep-area-card {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50% - 8px);
    min-width: 0;
  }

  .naplex-prep-area-card--totals {
    flex: 0 1 100%;
  }

  .naplex-prep-area-card--totals .naplex-prep-area-nodes {
    grid-template-columns: repeat(2, 1fr);
  }

  .naplex-prep-topbar-links a {
    font-size: 0.75rem;
    padding: 0.25rem 0.375rem;
    min-height: 40px;
  }

  .naplex-prep-topbar-cta {
    padding: 0.25rem 0.5rem !important;
    font-size: 0.75rem !important;
  }

  .naplex-prep-topbar-container {
    padding: 0 0.75rem;
  }

  .naplex-prep-topbar-logo {
    gap: 0.25rem;
  }

  .naplex-prep-topbar-bono {
    font-size: 0.875rem;
  }

  .naplex-prep-topbar-favicon {
    width: 20px;
    height: 20px;
  }

  .naplex-prep-topbar-rx {
    font-size: 0.6875rem;
  }
}

/* ---- Prefers reduced motion ---- */
@media (prefers-reduced-motion: reduce) {
  .naplex-animate {
    opacity: 1;
    transform: none;
    transition: none;
  }

  .naplex-prep-glow-1,
  .naplex-prep-glow-2,
  .naplex-prep-glow-3 {
    animation: none;
  }
}

/* ============================================
   FOUNDERS DISCOUNT (revertible — see config/foundersDiscount.js)
   ============================================ */

.naplex-prep-founders-banner {
  display: flex;
  width: fit-content;
  align-items: center;
  gap: 0.55rem;
  margin: 1rem auto 1.5rem;
  padding: 0.5rem 0.95rem 0.5rem 0.8rem;
  border-radius: 999px;
  font-family: var(--font-primary, 'Inter', system-ui, sans-serif);
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.025em;
  background: rgba(34, 197, 94, 0.10);
  border: 1px solid rgba(34, 197, 94, 0.35);
  color: #4ade80;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  white-space: nowrap;
  box-shadow: 0 0 22px rgba(34, 197, 94, 0.08), inset 0 0 0 1px rgba(255,255,255,0.02);
}

.naplex-prep-founders-banner--centered { margin: 0.75rem auto 1.5rem; }

.naplex-prep-founders-dot {
  width: 7px; height: 7px;
  border-radius: 50%;
  background: #4ade80;
  display: inline-block;
  box-shadow: 0 0 8px rgba(74, 222, 128, 0.85);
  animation: naplex-founders-pulse 2.4s ease-in-out infinite;
}

@keyframes naplex-founders-pulse {
  0%, 100% { opacity: 0.6; transform: scale(0.9); }
  50%      { opacity: 1;   transform: scale(1.1); }
}

.naplex-prep-founders-label {
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-weight: 700;
  font-size: 0.72rem;
}

.naplex-prep-founders-sep { opacity: 0.45; }

.naplex-prep-founders-was {
  text-decoration: line-through;
  text-decoration-color: rgba(239, 68, 68, 0.6);
  text-decoration-thickness: 2px;
  color: rgba(255, 255, 255, 0.55);
  font-weight: 600;
}

.naplex-prep-founders-now {
  color: #ffffff;
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: -0.01em;
}

.naplex-prep-founders-slots {
  text-transform: lowercase;
  letter-spacing: 0.03em;
  opacity: 0.85;
  font-weight: 500;
}

/* Strikethrough on stat strip + bottom price display */
.naplex-prep-stat-was {
  display: inline-block;
  font-size: 0.55em;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.4);
  text-decoration: line-through;
  text-decoration-color: rgba(239, 68, 68, 0.55);
  text-decoration-thickness: 1.5px;
  vertical-align: 0.6em;
  margin-right: 0.4rem;
  letter-spacing: -0.01em;
}

.naplex-prep-price-was {
  display: inline-block;
  font-size: 1.35rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.45);
  text-decoration: line-through;
  text-decoration-color: rgba(239, 68, 68, 0.6);
  text-decoration-thickness: 2px;
  margin-right: 0.6rem;
  vertical-align: 0.5rem;
  letter-spacing: -0.01em;
  font-family: var(--font-primary, 'Inter', system-ui, sans-serif);
}

@media (max-width: 640px) {
  /* The pill may still wrap on narrow phones / in-app browsers — when it
     does, the wrap must read as intentional: rows centered, not a ragged
     left-hanging second line (Edward 2026-06-12, iPhone screenshot).
     Tighter gap also keeps it one line on most 375px+ viewports. */
  .naplex-prep-founders-banner {
    font-size: 0.7rem;
    padding: 0.42rem 0.75rem 0.42rem 0.62rem;
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
    gap: 2px 0.4rem; /* tight rows when wrapped, tighter columns to avoid wrapping at all */
    max-width: calc(100% - 8px);
  }
  .naplex-prep-founders-now { font-size: 0.85rem; }
  .naplex-prep-price-was { font-size: 1rem; }
}

/* ===== Mobile-tailored polish (Edward 2026-06-12) =====
   Brings the DLC landing pages in line with the MAIN landing's mobile
   language. Structure and copy untouched — this is chrome only. Applies to
   all three pages (Mpje/Ptcb @import this file). Appended at end of file so
   it overrides earlier rules by order. */
@media (max-width: 768px) {
  /* -- Topbar: the fixed desktop nav strip reads as dated app chrome on
        phones — the main landing is chromeless on mobile (brand lives in
        the hero). Un-pin it (absolute: scrolls away with the hero) and let
        it float transparent over the hero glow; no border strip, no solid
        fill. Layout is unchanged (absolute occupies no flow, same as fixed). */
  .naplex-prep-topbar {
    position: absolute;
    background: transparent;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    border-bottom: none;
  }

  /* The blue Sign Up chip was off-accent on every page (naplex is green,
     ptcb amber); a neutral glass pill matches the main landing's ghost CTA
     and works over all three accent washes. Base rules carry !important. */
  .naplex-prep-topbar-cta {
    background: rgba(255, 255, 255, 0.07) !important;
    border-color: rgba(255, 255, 255, 0.16);
    color: #f3f4f6 !important;
    border-radius: 9999px !important;
  }

  /* -- Card surfaces: the flat fill reads dated next to the main landing's
        gradient-glass cards — same recipe here. */
  .naplex-prep-flow-card,
  .naplex-prep-yield-card,
  .naplex-prep-node-card,
  .naplex-prep-compare-card {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.045) 0%, rgba(255, 255, 255, 0.015) 100%);
  }

  /* -- Corner treatment (mirrors the main landing's mobile cards): the
        icon/number tiles that sat ABOVE titles burn a vertical row each —
        dock them top-right and let the title reclaim the column. */
  .naplex-prep-node-card {
    position: relative;
  }

  .naplex-prep-node-icon {
    position: absolute;
    top: var(--space-5);
    right: var(--space-5);
    margin-bottom: 0;
  }

  .naplex-prep-node-card h3 {
    padding-right: 52px;
    min-height: 40px;
    display: flex;
    align-items: center;
  }

  .naplex-prep-flow-card {
    position: relative;
  }

  .naplex-prep-flow-num {
    position: absolute;
    top: var(--space-5);
    right: var(--space-5);
    margin-bottom: 0;
  }

  .naplex-prep-flow-card h3 {
    padding-right: 44px;
    min-height: 32px;
    display: flex;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/NaplexPrep.css"],"names":[],"mappings":"AAAA;;;;iDAIiD;;AAEjD,qBAAqB;AACrB;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kEAAkE;AACpE;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,KAAK,mCAAmC,EAAE;EAC1C,MAAM,6CAA6C,EAAE;EACrD,OAAO,6CAA6C,EAAE;AACxD;;AAEA,iFAAiF;AACjF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,kDAAkD;EAClD,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gFAAgF;EAChF,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gFAAgF;EAChF,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mCAAmC;EACnC,wCAAwC;EACxC,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,yCAAyC;;AAEzC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,+CAA+C;EAC/C,yCAAyC;EACzC,6BAA6B;EAC7B,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;EAC/C,qCAAqC;EACrC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,UAAU;EACV,mCAAmC;EACnC,cAAc;EACd,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;EACd,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;EACzB,qCAAqC;EACrC,sCAAsC;EACtC,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,iCAAiC;EACjC,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE,8DAA8D;EAC9D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;EACd,2BAA2B;EAC3B,wCAAwC;EACxC,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,wCAAwC;EACxC,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,uBAAuB;EACvB,uCAAuC;EACvC,4BAA4B;EAC5B,2BAA2B;EAC3B,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,0CAA0C;EAC1C,6CAA6C;EAC7C,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;AACrC;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,gCAAgC;EAChC,uBAAuB;EACvB,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,mCAAmC;EACnC,SAAS;AACX;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,gCAAgC;EAChC,uBAAuB;EACvB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kDAAkD;EAClD,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,sDAAsD;EACtD,2BAA2B;EAC3B;sDACoD;EACpD,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,cAAc;EACd,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,wBAAwB;EACxB,qCAAqC;EACrC,2CAA2C;EAC3C,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,oCAAoC;EACpC,qCAAqC;EACrC,YAAyB;EAAzB,cAAyB;EAAzB,2BAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,gCAAgC;EAChC,uBAAuB;EACvB,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;EACzB,qCAAqC;EACrC,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,gCAAgC;EAChC,uBAAuB;EACvB,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,mCAAmC;EACnC,SAAS;AACX;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,gCAAgC;EAChC,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;EACzB,sCAAsC;EACtC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wDAAwD;AACxD;EACE,UAAU;EACV,2BAA2B;EAC3B;0DACwD;AAC1D;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB,uDAAuD,oBAAoB,EAAE;AAC7E,uDAAuD,uBAAuB,EAAE;AAChF,uDAAuD,uBAAuB,EAAE;AAChF,uDAAuD,uBAAuB,EAAE;AAChF,uDAAuD,uBAAuB,EAAE;AAChF,uDAAuD,uBAAuB,EAAE;AAChF,uDAAuD,uBAAuB,EAAE;AAChF,uDAAuD,uBAAuB,EAAE;AAChF,uDAAuD,uBAAuB,EAAE;AAChF,wDAAwD,uBAAuB,EAAE;AACjF,wDAAwD,uBAAuB,EAAE;AACjF,wDAAwD,uBAAuB,EAAE;AACjF,wDAAwD,uBAAuB,EAAE;AACjF,wDAAwD,uBAAuB,EAAE;AACjF,wDAAwD,uBAAuB,EAAE;AACjF,wDAAwD,uBAAuB,EAAE;;AAEjF,kDAAkD,oBAAoB,EAAE;AACxE,kDAAkD,uBAAuB,EAAE;AAC3E,kDAAkD,uBAAuB,EAAE;AAC3E,kDAAkD,uBAAuB,EAAE;AAC3E,kDAAkD,uBAAuB,EAAE;AAC3E,kDAAkD,uBAAuB,EAAE;;AAE3E,yBAAyB;AACzB;EACE;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;6EAC2E;EAC3E;IACE,oBAAoB;IACpB,wBAAwB;IACxB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,qCAAqC;IACrC,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,kCAAkC;IAClC,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;IAGE,eAAe;EACjB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,qCAAqC;EACrC,oBAAoB;EACpB,gEAAgE;EAChE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,oFAAoF;AACtF;;AAEA,yCAAyC,2BAA2B,EAAE;;AAEtE;EACE,UAAU,EAAE,WAAW;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;EAC5C,0DAA0D;AAC5D;;AAEA;EACE,WAAW,YAAY,EAAE,qBAAqB,EAAE;EAChD,WAAW,UAAU,IAAI,qBAAqB,EAAE;AAClD;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,4BAA4B,aAAa,EAAE;;AAE3C;EACE,6BAA6B;EAC7B,6CAA6C;EAC7C,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;EAC7B,8CAA8C;EAC9C,gCAAgC;EAChC,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;EAC7B,6CAA6C;EAC7C,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,gEAAgE;AAClE;;AAEA;EACE;;;mEAGiE;EACjE;IACE,iBAAiB;IACjB,wCAAwC;IACxC,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,eAAe,EAAE,sEAAsE;IACvF,2BAA2B;EAC7B;EACA,4BAA4B,kBAAkB,EAAE;EAChD,yBAAyB,eAAe,EAAE;AAC5C;;AAEA;;;;yCAIyC;AACzC;EACE;;;;+EAI6E;EAC7E;IACE,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;;2EAEyE;EACzE;IACE,gDAAgD;IAChD,uCAAuC;IACvC,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;kDACgD;EAChD;;;;IAIE,mGAAmG;EACrG;;EAEA;;mEAEiE;EACjE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;AACF","sourcesContent":["/* ============================================\n   NAPLEX PREP DLC PAGE — Dark glassmorphism theme\n   Matches Landing + Pricing design language\n   Green accent (#10b981 / #34d399)\n   ============================================ */\n\n/* ---- Layout ---- */\n.naplex-prep {\n  min-height: 100vh;\n  background: var(--bg-base);\n  color: var(--text-primary);\n  font-family: var(--font-primary);\n  position: relative;\n  overflow-x: hidden;\n  padding-top: 64px;\n}\n\n/* ---- Ambient background glows ---- */\n.naplex-prep-bg {\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  z-index: 0;\n  overflow: hidden;\n}\n\n.naplex-prep-glow {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(120px);\n  opacity: 0.12;\n}\n\n.naplex-prep-glow-1 {\n  width: 600px;\n  height: 600px;\n  background: #10b981;\n  top: -200px;\n  left: 50%;\n  transform: translateX(-50%);\n  animation: naplex-drift 20s ease-in-out infinite alternate;\n}\n\n.naplex-prep-glow-2 {\n  width: 500px;\n  height: 500px;\n  background: #ef4444;\n  bottom: 20%;\n  left: -150px;\n  animation: naplex-drift 25s ease-in-out infinite alternate-reverse;\n}\n\n.naplex-prep-glow-3 {\n  width: 400px;\n  height: 400px;\n  background: #0ea5e9;\n  bottom: 10%;\n  right: -100px;\n  animation: naplex-drift 22s ease-in-out infinite alternate;\n}\n\n@keyframes naplex-drift {\n  0% { transform: translate(0, 0) scale(1); }\n  50% { transform: translate(30px, -20px) scale(1.05); }\n  100% { transform: translate(-20px, 15px) scale(0.95); }\n}\n\n/* ---- Top bar (matches real TopNav: full-width, fixed, blurred backdrop) ---- */\n.naplex-prep-topbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 64px;\n  background: rgba(10, 10, 10, 0.95);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n}\n\n.naplex-prep-topbar-container {\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 0 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 100%;\n}\n\n.naplex-prep-topbar-logo {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  gap: 0.5rem;\n  padding: 0.25rem 0;\n  transition: opacity 0.2s ease;\n}\n\n.naplex-prep-topbar-logo:hover {\n  opacity: 0.85;\n}\n\n.naplex-prep-topbar-bono {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: 0.28em;\n  color: #ffffff;\n  text-transform: uppercase;\n  line-height: 1;\n}\n\n.naplex-prep-topbar-favicon {\n  height: 32px;\n  width: 32px;\n  display: block;\n  object-fit: contain;\n}\n\n.naplex-prep-topbar-rx {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #f87171;\n  background: rgba(239, 68, 68, 0.15);\n  border: 1px solid rgba(239, 68, 68, 0.4);\n  border-radius: 9999px;\n  padding: 0.25rem 0.6rem;\n  margin-left: 0.5rem;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n}\n\n/* logo hover handled by parent opacity */\n\n.naplex-prep-topbar-links {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.naplex-prep-topbar-links a {\n  color: #9ca3af;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 0.9375rem;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.naplex-prep-topbar-links a:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.naplex-prep-topbar-cta {\n  padding: 0.5rem 1rem !important;\n  background: rgba(59, 130, 246, 0.15) !important;\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  border-radius: 8px !important;\n  color: #60a5fa !important;\n  font-size: 0.875rem !important;\n  font-weight: 600 !important;\n  transition: all 0.2s ease !important;\n}\n\n.naplex-prep-topbar-cta:hover {\n  background: rgba(59, 130, 246, 0.25) !important;\n  border-color: rgba(59, 130, 246, 0.5);\n  color: #93c5fd !important;\n  transform: translateY(-1px);\n}\n\n/* ---- Section wrapper ---- */\n.naplex-prep-inner {\n  position: relative;\n  z-index: 1;\n  max-width: var(--container-content);\n  margin: 0 auto;\n  padding: 0 var(--space-6);\n}\n\n/* ---- Hero ---- */\n.naplex-prep-hero {\n  text-align: center;\n  padding: clamp(4rem, 10vh, 7rem) 0 var(--space-12);\n}\n\n.naplex-prep-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  background: rgba(16, 185, 129, 0.12);\n  border: 1px solid rgba(16, 185, 129, 0.3);\n  color: #34d399;\n  font-size: var(--text-xs);\n  font-weight: var(--font-weight-semibold);\n  text-transform: uppercase;\n  letter-spacing: var(--tracking-wider);\n  padding: var(--space-1) var(--space-4);\n  border-radius: var(--radius-full);\n  margin-bottom: var(--space-6);\n}\n\n.naplex-prep-hero h1 {\n  font-size: clamp(2rem, 5vw, 3.5rem);\n  font-weight: var(--font-weight-bold);\n  line-height: var(--leading-tight);\n  margin: 0 0 var(--space-4);\n  filter: drop-shadow(0 0 60px rgba(16, 185, 129, 0.15));\n}\n\n.naplex-prep-hero h1 span {\n  background: linear-gradient(135deg, #34d399, #10b981, #059669);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.naplex-prep-hero-sub {\n  font-size: var(--text-lg);\n  color: var(--text-muted);\n  max-width: 640px;\n  margin: 0 auto var(--space-8);\n  line-height: var(--leading-relaxed);\n}\n\n.naplex-prep-hero-cta {\n  display: flex;\n  gap: var(--space-4);\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.naplex-prep-btn-primary {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-3) var(--space-8);\n  background: rgba(16, 185, 129, 0.15);\n  border: 1px solid rgba(16, 185, 129, 0.4);\n  color: #34d399;\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-semibold);\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  text-decoration: none;\n  transition: all var(--transition-normal);\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.naplex-prep-btn-primary:hover {\n  background: rgba(16, 185, 129, 0.25);\n  border-color: rgba(16, 185, 129, 0.6);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 20px rgba(16, 185, 129, 0.2);\n}\n\n.naplex-prep-btn-ghost {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-3) var(--space-8);\n  background: transparent;\n  border: 1px solid var(--border-default);\n  color: var(--text-secondary);\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-medium);\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  text-decoration: none;\n  transition: all var(--transition-normal);\n}\n\n.naplex-prep-btn-ghost:hover {\n  border-color: var(--border-strong);\n  color: var(--text-primary);\n  transform: translateY(-1px);\n}\n\n/* ---- Stat strip ---- */\n.naplex-prep-stats {\n  display: flex;\n  justify-content: center;\n  gap: var(--space-10);\n  flex-wrap: wrap;\n  padding: var(--space-8) 0;\n  border-top: 1px solid var(--border-subtle);\n  border-bottom: 1px solid var(--border-subtle);\n  margin-bottom: var(--space-16);\n}\n\n.naplex-prep-stat {\n  text-align: center;\n}\n\n.naplex-prep-stat-value {\n  font-size: var(--text-3xl);\n  font-weight: var(--font-weight-bold);\n  color: #34d399;\n  display: block;\n}\n\n.naplex-prep-stat-label {\n  font-size: var(--text-sm);\n  color: var(--text-muted);\n  margin-top: var(--space-1);\n}\n\n/* ---- Section headings ---- */\n.naplex-prep-section {\n  margin-bottom: var(--space-16);\n}\n\n.naplex-prep-section-header {\n  text-align: center;\n  margin-bottom: var(--space-8);\n}\n\n.naplex-prep-section-header h2 {\n  font-size: clamp(1.5rem, 3vw, 2rem);\n  font-weight: var(--font-weight-bold);\n  margin: 0 0 var(--space-3);\n}\n\n.naplex-prep-section-header p {\n  font-size: var(--text-base);\n  color: var(--text-muted);\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: var(--leading-relaxed);\n}\n\n/* ---- How it works — 3-step flow ---- */\n.naplex-prep-flow {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr auto 1fr;\n  gap: var(--space-4);\n  align-items: stretch;\n}\n\n.naplex-prep-flow-arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-subtle);\n  font-size: 1.5rem;\n}\n\n.naplex-prep-flow-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-2xl);\n  padding: var(--space-6);\n  backdrop-filter: var(--glass-blur);\n  transition: all var(--transition-normal);\n}\n\n.naplex-prep-flow-card:hover {\n  border-color: var(--border-default);\n  transform: translateY(-4px);\n}\n\n.naplex-prep-flow-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-full);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-bold);\n  margin-bottom: var(--space-3);\n}\n\n.naplex-prep-flow-num--1 {\n  background: rgba(239, 68, 68, 0.15);\n  color: #ef4444;\n  border: 1px solid rgba(239, 68, 68, 0.3);\n}\n\n.naplex-prep-flow-num--2 {\n  background: rgba(16, 185, 129, 0.15);\n  color: #34d399;\n  border: 1px solid rgba(16, 185, 129, 0.3);\n}\n\n.naplex-prep-flow-num--3 {\n  background: rgba(34, 197, 94, 0.15);\n  color: #22c55e;\n  border: 1px solid rgba(34, 197, 94, 0.3);\n}\n\n.naplex-prep-flow-card h3 {\n  font-size: var(--text-lg);\n  font-weight: var(--font-weight-semibold);\n  margin: 0 0 var(--space-2);\n}\n\n.naplex-prep-flow-card p {\n  font-size: var(--text-sm);\n  color: var(--text-muted);\n  line-height: var(--leading-relaxed);\n  margin: 0;\n}\n\n/* ---- Therapeutic areas grid ---- */\n.naplex-prep-areas-grid {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: var(--space-4);\n}\n\n.naplex-prep-area-card {\n  position: relative;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: var(--radius-2xl);\n  padding: var(--space-5);\n  backdrop-filter: var(--glass-blur-strong);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  flex: 0 1 calc(25% - 12px);\n  min-width: 210px;\n}\n\n.naplex-prep-area-card-glow {\n  position: absolute;\n  top: -40px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 120px;\n  height: 80px;\n  background: var(--area-color);\n  border-radius: 50%;\n  filter: blur(50px);\n  opacity: 0.08;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n}\n\n.naplex-prep-area-card:hover {\n  border-color: var(--area-color, var(--border-default));\n  transform: translateY(-4px);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3),\n              0 0 0 1px var(--area-color, transparent);\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.naplex-prep-area-card:hover .naplex-prep-area-card-glow {\n  opacity: 0.18;\n}\n\n.naplex-prep-area-header {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n.naplex-prep-area-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: var(--radius-full);\n  flex-shrink: 0;\n  background: var(--area-color);\n  box-shadow: 0 0 8px var(--area-color);\n}\n\n.naplex-prep-area-name {\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-semibold);\n}\n\n.naplex-prep-area-nodes {\n  display: flex;\n  gap: var(--space-2);\n  flex-wrap: wrap;\n}\n\n.naplex-prep-area-node {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: var(--text-xs);\n  color: var(--text-muted);\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: var(--radius-md);\n  padding: 3px 7px;\n}\n\n.naplex-prep-area-node svg {\n  color: var(--area-color);\n  opacity: 0.8;\n  flex-shrink: 0;\n}\n\n/* Totals card — stands out from per-area cards */\n.naplex-prep-area-card--totals {\n  background: rgba(16, 185, 129, 0.05);\n  border-color: rgba(16, 185, 129, 0.2);\n  flex: 0 1 calc(50% - 8px);\n}\n\n.naplex-prep-area-card--totals .naplex-prep-area-name {\n  color: #34d399;\n  font-size: var(--text-base);\n}\n\n.naplex-prep-area-card--totals .naplex-prep-area-nodes {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: var(--space-2);\n}\n\n.naplex-prep-area-card--totals .naplex-prep-area-node {\n  background: rgba(16, 185, 129, 0.06);\n  border-color: rgba(16, 185, 129, 0.12);\n  min-width: 0;\n  justify-content: center;\n  padding: 3px 5px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.naplex-prep-area-card--totals .naplex-prep-area-node span {\n  color: var(--text-primary);\n  font-weight: var(--font-weight-semibold);\n}\n\n.naplex-prep-area-card--totals .naplex-prep-area-node--label {\n  color: var(--text-secondary);\n  font-weight: var(--font-weight-medium);\n}\n\n/* ---- Yield spectrum ---- */\n.naplex-prep-yield {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-4);\n}\n\n.naplex-prep-yield-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-2xl);\n  padding: var(--space-6);\n  backdrop-filter: var(--glass-blur);\n  transition: all var(--transition-normal);\n}\n\n.naplex-prep-yield-card:hover {\n  border-color: var(--border-default);\n}\n\n.naplex-prep-yield-card h3 {\n  font-size: var(--text-lg);\n  font-weight: var(--font-weight-semibold);\n  margin: 0 0 var(--space-2);\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.naplex-prep-yield-tag {\n  font-size: var(--text-xs);\n  font-weight: var(--font-weight-semibold);\n  text-transform: uppercase;\n  letter-spacing: var(--tracking-wider);\n  padding: 2px var(--space-2);\n  border-radius: var(--radius-sm);\n}\n\n.naplex-prep-yield-tag--high {\n  background: rgba(239, 68, 68, 0.15);\n  color: #ef4444;\n  border: 1px solid rgba(239, 68, 68, 0.3);\n}\n\n.naplex-prep-yield-tag--medium {\n  background: rgba(245, 158, 11, 0.15);\n  color: #f59e0b;\n  border: 1px solid rgba(245, 158, 11, 0.3);\n}\n\n.naplex-prep-yield-tag--low {\n  background: rgba(14, 165, 233, 0.15);\n  color: #0ea5e9;\n  border: 1px solid rgba(14, 165, 233, 0.3);\n}\n\n.naplex-prep-yield-card p {\n  font-size: var(--text-sm);\n  color: var(--text-muted);\n  line-height: var(--leading-relaxed);\n  margin: 0 0 var(--space-3);\n}\n\n.naplex-prep-yield-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.naplex-prep-yield-list li {\n  font-size: var(--text-sm);\n  color: var(--text-secondary);\n  padding: var(--space-1) 0;\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-2);\n}\n\n.naplex-prep-yield-list li::before {\n  content: '';\n  display: inline-block;\n  width: 4px;\n  height: 4px;\n  border-radius: var(--radius-full);\n  background: var(--text-subtle);\n  flex-shrink: 0;\n  margin-top: 7px;\n}\n\n/* ---- Node types (what you encounter) ---- */\n.naplex-prep-nodes {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: var(--space-4);\n}\n\n.naplex-prep-node-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-2xl);\n  padding: var(--space-6);\n  backdrop-filter: var(--glass-blur);\n  transition: all var(--transition-normal);\n}\n\n.naplex-prep-node-card:hover {\n  border-color: var(--border-default);\n  transform: translateY(-2px);\n}\n\n.naplex-prep-node-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-lg);\n  margin-bottom: var(--space-3);\n}\n\n.naplex-prep-node-card h3 {\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-semibold);\n  margin: 0 0 var(--space-2);\n}\n\n.naplex-prep-node-card p {\n  font-size: var(--text-sm);\n  color: var(--text-muted);\n  line-height: var(--leading-relaxed);\n  margin: 0;\n}\n\n/* ---- Differentiators — comparison ---- */\n.naplex-prep-compare {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-6);\n}\n\n.naplex-prep-compare-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-2xl);\n  padding: var(--space-6);\n  backdrop-filter: var(--glass-blur);\n}\n\n.naplex-prep-compare-card--them {\n  opacity: 0.7;\n}\n\n.naplex-prep-compare-card--us {\n  border-color: rgba(16, 185, 129, 0.3);\n}\n\n.naplex-prep-compare-label {\n  font-size: var(--text-xs);\n  font-weight: var(--font-weight-semibold);\n  text-transform: uppercase;\n  letter-spacing: var(--tracking-widest);\n  color: var(--text-subtle);\n  margin-bottom: var(--space-4);\n}\n\n.naplex-prep-compare-card--us .naplex-prep-compare-label {\n  color: #34d399;\n}\n\n.naplex-prep-compare-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.naplex-prep-compare-list li {\n  font-size: var(--text-sm);\n  color: var(--text-secondary);\n  padding: var(--space-2) 0;\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n  line-height: var(--leading-relaxed);\n}\n\n.naplex-prep-compare-icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.naplex-prep-compare-card--them .naplex-prep-compare-icon {\n  color: var(--text-subtle);\n}\n\n.naplex-prep-compare-card--us .naplex-prep-compare-icon {\n  color: #22c55e;\n}\n\n/* ---- Bottom CTA ---- */\n.naplex-prep-bottom-cta {\n  text-align: center;\n  padding: var(--space-16) 0;\n  border-top: 1px solid var(--border-subtle);\n}\n\n.naplex-prep-bottom-cta h2 {\n  font-size: clamp(1.5rem, 3vw, 2rem);\n  font-weight: var(--font-weight-bold);\n  margin: 0 0 var(--space-3);\n}\n\n.naplex-prep-bottom-cta p {\n  font-size: var(--text-base);\n  color: var(--text-muted);\n  margin: 0 0 var(--space-6);\n}\n\n.naplex-prep-price-display {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: var(--space-2);\n  margin-bottom: var(--space-6);\n}\n\n.naplex-prep-price-amount {\n  font-size: var(--text-4xl);\n  font-weight: var(--font-weight-bold);\n  color: #34d399;\n}\n\n.naplex-prep-price-period {\n  font-size: var(--text-lg);\n  color: var(--text-muted);\n}\n\n.naplex-prep-price-note {\n  font-size: var(--text-sm);\n  color: var(--text-subtle);\n  margin-bottom: var(--space-6);\n}\n\n/* ---- Footer nav ---- */\n.naplex-prep-footer {\n  text-align: center;\n  padding: var(--space-8) 0;\n  border-top: 1px solid var(--border-subtle);\n}\n\n.naplex-prep-footer-links {\n  display: flex;\n  justify-content: center;\n  gap: var(--space-6);\n  flex-wrap: wrap;\n}\n\n.naplex-prep-footer-links a {\n  font-size: var(--text-sm);\n  color: var(--text-muted);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\n.naplex-prep-footer-links a:hover {\n  color: var(--text-primary);\n}\n\n/* ---- Scroll animation (reuses landing pattern) ---- */\n.naplex-animate {\n  opacity: 0;\n  transform: translateY(24px);\n  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),\n              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.naplex-animate.naplex-visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Stagger children */\n.naplex-prep-areas-grid .naplex-animate:nth-child(1) { transition-delay: 0s; }\n.naplex-prep-areas-grid .naplex-animate:nth-child(2) { transition-delay: 0.03s; }\n.naplex-prep-areas-grid .naplex-animate:nth-child(3) { transition-delay: 0.06s; }\n.naplex-prep-areas-grid .naplex-animate:nth-child(4) { transition-delay: 0.09s; }\n.naplex-prep-areas-grid .naplex-animate:nth-child(5) { transition-delay: 0.12s; }\n.naplex-prep-areas-grid .naplex-animate:nth-child(6) { transition-delay: 0.15s; }\n.naplex-prep-areas-grid .naplex-animate:nth-child(7) { transition-delay: 0.18s; }\n.naplex-prep-areas-grid .naplex-animate:nth-child(8) { transition-delay: 0.21s; }\n.naplex-prep-areas-grid .naplex-animate:nth-child(9) { transition-delay: 0.24s; }\n.naplex-prep-areas-grid .naplex-animate:nth-child(10) { transition-delay: 0.27s; }\n.naplex-prep-areas-grid .naplex-animate:nth-child(11) { transition-delay: 0.30s; }\n.naplex-prep-areas-grid .naplex-animate:nth-child(12) { transition-delay: 0.33s; }\n.naplex-prep-areas-grid .naplex-animate:nth-child(13) { transition-delay: 0.36s; }\n.naplex-prep-areas-grid .naplex-animate:nth-child(14) { transition-delay: 0.39s; }\n.naplex-prep-areas-grid .naplex-animate:nth-child(15) { transition-delay: 0.42s; }\n.naplex-prep-areas-grid .naplex-animate:nth-child(16) { transition-delay: 0.45s; }\n\n.naplex-prep-nodes .naplex-animate:nth-child(1) { transition-delay: 0s; }\n.naplex-prep-nodes .naplex-animate:nth-child(2) { transition-delay: 0.06s; }\n.naplex-prep-nodes .naplex-animate:nth-child(3) { transition-delay: 0.12s; }\n.naplex-prep-nodes .naplex-animate:nth-child(4) { transition-delay: 0.18s; }\n.naplex-prep-nodes .naplex-animate:nth-child(5) { transition-delay: 0.24s; }\n.naplex-prep-nodes .naplex-animate:nth-child(6) { transition-delay: 0.30s; }\n\n/* ---- Responsive ---- */\n@media (max-width: 768px) {\n  .naplex-prep-flow {\n    grid-template-columns: 1fr;\n    gap: var(--space-3);\n  }\n\n  .naplex-prep-flow-arrow {\n    transform: rotate(90deg);\n    padding: var(--space-1) 0;\n  }\n\n  .naplex-prep-nodes {\n    grid-template-columns: 1fr;\n  }\n\n  .naplex-prep-compare {\n    grid-template-columns: 1fr;\n  }\n\n  .naplex-prep-yield {\n    grid-template-columns: 1fr;\n  }\n\n  .naplex-prep-area-card {\n    flex: 0 1 calc(50% - 8px);\n    min-width: 140px;\n  }\n\n  .naplex-prep-area-card--totals {\n    flex: 0 1 calc(50% - 8px);\n  }\n\n  .naplex-prep-stats {\n    gap: var(--space-6);\n  }\n\n  .naplex-prep-area-card--totals .naplex-prep-area-nodes {\n    grid-template-columns: repeat(4, 1fr);\n  }\n\n  /* Thumb-sized tap targets: keep the compact type, grow the hit area to\n     ~40px via min-height + flex centering (Edward 2026-06-12 mobile pass). */\n  .naplex-prep-topbar-links a {\n    font-size: 0.8125rem;\n    padding: 0.375rem 0.5rem;\n    min-height: 40px;\n    display: inline-flex;\n    align-items: center;\n  }\n\n  .naplex-prep-topbar-links {\n    gap: 0.25rem;\n  }\n\n  .naplex-prep-topbar-cta {\n    padding: 0.375rem 0.625rem !important;\n    font-size: 0.8125rem !important;\n  }\n\n  .naplex-prep-topbar-logo {\n    padding: 0.5rem 0;\n    min-height: 40px;\n  }\n\n  .naplex-prep-topbar-container {\n    padding: 0 1rem;\n  }\n\n  .naplex-prep-footer-links a {\n    padding: 0.625rem 0.5rem;\n    display: inline-flex;\n    align-items: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .naplex-prep-inner {\n    padding: 0 var(--space-4);\n  }\n\n  .naplex-prep-area-card {\n    flex: 0 1 calc(50% - 8px);\n    min-width: 0;\n  }\n\n  .naplex-prep-area-card--totals {\n    flex: 0 1 100%;\n  }\n\n  .naplex-prep-area-card--totals .naplex-prep-area-nodes {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .naplex-prep-topbar-links a {\n    font-size: 0.75rem;\n    padding: 0.25rem 0.375rem;\n    min-height: 40px;\n  }\n\n  .naplex-prep-topbar-cta {\n    padding: 0.25rem 0.5rem !important;\n    font-size: 0.75rem !important;\n  }\n\n  .naplex-prep-topbar-container {\n    padding: 0 0.75rem;\n  }\n\n  .naplex-prep-topbar-logo {\n    gap: 0.25rem;\n  }\n\n  .naplex-prep-topbar-bono {\n    font-size: 0.875rem;\n  }\n\n  .naplex-prep-topbar-favicon {\n    width: 20px;\n    height: 20px;\n  }\n\n  .naplex-prep-topbar-rx {\n    font-size: 0.6875rem;\n  }\n}\n\n/* ---- Prefers reduced motion ---- */\n@media (prefers-reduced-motion: reduce) {\n  .naplex-animate {\n    opacity: 1;\n    transform: none;\n    transition: none;\n  }\n\n  .naplex-prep-glow-1,\n  .naplex-prep-glow-2,\n  .naplex-prep-glow-3 {\n    animation: none;\n  }\n}\n\n/* ============================================\n   FOUNDERS DISCOUNT (revertible — see config/foundersDiscount.js)\n   ============================================ */\n\n.naplex-prep-founders-banner {\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  gap: 0.55rem;\n  margin: 1rem auto 1.5rem;\n  padding: 0.5rem 0.95rem 0.5rem 0.8rem;\n  border-radius: 999px;\n  font-family: var(--font-primary, 'Inter', system-ui, sans-serif);\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.025em;\n  background: rgba(34, 197, 94, 0.10);\n  border: 1px solid rgba(34, 197, 94, 0.35);\n  color: #4ade80;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  white-space: nowrap;\n  box-shadow: 0 0 22px rgba(34, 197, 94, 0.08), inset 0 0 0 1px rgba(255,255,255,0.02);\n}\n\n.naplex-prep-founders-banner--centered { margin: 0.75rem auto 1.5rem; }\n\n.naplex-prep-founders-dot {\n  width: 7px; height: 7px;\n  border-radius: 50%;\n  background: #4ade80;\n  display: inline-block;\n  box-shadow: 0 0 8px rgba(74, 222, 128, 0.85);\n  animation: naplex-founders-pulse 2.4s ease-in-out infinite;\n}\n\n@keyframes naplex-founders-pulse {\n  0%, 100% { opacity: 0.6; transform: scale(0.9); }\n  50%      { opacity: 1;   transform: scale(1.1); }\n}\n\n.naplex-prep-founders-label {\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  font-weight: 700;\n  font-size: 0.72rem;\n}\n\n.naplex-prep-founders-sep { opacity: 0.45; }\n\n.naplex-prep-founders-was {\n  text-decoration: line-through;\n  text-decoration-color: rgba(239, 68, 68, 0.6);\n  text-decoration-thickness: 2px;\n  color: rgba(255, 255, 255, 0.55);\n  font-weight: 600;\n}\n\n.naplex-prep-founders-now {\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 0.95rem;\n  letter-spacing: -0.01em;\n}\n\n.naplex-prep-founders-slots {\n  text-transform: lowercase;\n  letter-spacing: 0.03em;\n  opacity: 0.85;\n  font-weight: 500;\n}\n\n/* Strikethrough on stat strip + bottom price display */\n.naplex-prep-stat-was {\n  display: inline-block;\n  font-size: 0.55em;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.4);\n  text-decoration: line-through;\n  text-decoration-color: rgba(239, 68, 68, 0.55);\n  text-decoration-thickness: 1.5px;\n  vertical-align: 0.6em;\n  margin-right: 0.4rem;\n  letter-spacing: -0.01em;\n}\n\n.naplex-prep-price-was {\n  display: inline-block;\n  font-size: 1.35rem;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.45);\n  text-decoration: line-through;\n  text-decoration-color: rgba(239, 68, 68, 0.6);\n  text-decoration-thickness: 2px;\n  margin-right: 0.6rem;\n  vertical-align: 0.5rem;\n  letter-spacing: -0.01em;\n  font-family: var(--font-primary, 'Inter', system-ui, sans-serif);\n}\n\n@media (max-width: 640px) {\n  /* The pill may still wrap on narrow phones / in-app browsers — when it\n     does, the wrap must read as intentional: rows centered, not a ragged\n     left-hanging second line (Edward 2026-06-12, iPhone screenshot).\n     Tighter gap also keeps it one line on most 375px+ viewports. */\n  .naplex-prep-founders-banner {\n    font-size: 0.7rem;\n    padding: 0.42rem 0.75rem 0.42rem 0.62rem;\n    flex-wrap: wrap;\n    justify-content: center;\n    text-align: center;\n    gap: 2px 0.4rem; /* tight rows when wrapped, tighter columns to avoid wrapping at all */\n    max-width: calc(100% - 8px);\n  }\n  .naplex-prep-founders-now { font-size: 0.85rem; }\n  .naplex-prep-price-was { font-size: 1rem; }\n}\n\n/* ===== Mobile-tailored polish (Edward 2026-06-12) =====\n   Brings the DLC landing pages in line with the MAIN landing's mobile\n   language. Structure and copy untouched — this is chrome only. Applies to\n   all three pages (Mpje/Ptcb @import this file). Appended at end of file so\n   it overrides earlier rules by order. */\n@media (max-width: 768px) {\n  /* -- Topbar: the fixed desktop nav strip reads as dated app chrome on\n        phones — the main landing is chromeless on mobile (brand lives in\n        the hero). Un-pin it (absolute: scrolls away with the hero) and let\n        it float transparent over the hero glow; no border strip, no solid\n        fill. Layout is unchanged (absolute occupies no flow, same as fixed). */\n  .naplex-prep-topbar {\n    position: absolute;\n    background: transparent;\n    backdrop-filter: none;\n    -webkit-backdrop-filter: none;\n    border-bottom: none;\n  }\n\n  /* The blue Sign Up chip was off-accent on every page (naplex is green,\n     ptcb amber); a neutral glass pill matches the main landing's ghost CTA\n     and works over all three accent washes. Base rules carry !important. */\n  .naplex-prep-topbar-cta {\n    background: rgba(255, 255, 255, 0.07) !important;\n    border-color: rgba(255, 255, 255, 0.16);\n    color: #f3f4f6 !important;\n    border-radius: 9999px !important;\n  }\n\n  /* -- Card surfaces: the flat fill reads dated next to the main landing's\n        gradient-glass cards — same recipe here. */\n  .naplex-prep-flow-card,\n  .naplex-prep-yield-card,\n  .naplex-prep-node-card,\n  .naplex-prep-compare-card {\n    background: linear-gradient(180deg, rgba(255, 255, 255, 0.045) 0%, rgba(255, 255, 255, 0.015) 100%);\n  }\n\n  /* -- Corner treatment (mirrors the main landing's mobile cards): the\n        icon/number tiles that sat ABOVE titles burn a vertical row each —\n        dock them top-right and let the title reclaim the column. */\n  .naplex-prep-node-card {\n    position: relative;\n  }\n\n  .naplex-prep-node-icon {\n    position: absolute;\n    top: var(--space-5);\n    right: var(--space-5);\n    margin-bottom: 0;\n  }\n\n  .naplex-prep-node-card h3 {\n    padding-right: 52px;\n    min-height: 40px;\n    display: flex;\n    align-items: center;\n  }\n\n  .naplex-prep-flow-card {\n    position: relative;\n  }\n\n  .naplex-prep-flow-num {\n    position: absolute;\n    top: var(--space-5);\n    right: var(--space-5);\n    margin-bottom: 0;\n  }\n\n  .naplex-prep-flow-card h3 {\n    padding-right: 44px;\n    min-height: 32px;\n    display: flex;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
